"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contact = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Contact = ({
  contact,
  type
}) => {
  if (!contact) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [type === 'email' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Email, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Telephone, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      href: `${type === 'email' ? 'mailto' : 'tel'}:${contact}`,
      children: contact
    })]
  });
};
exports.Contact = Contact;
